import { render, staticRenderFns } from "./ViewSelector.vue?vue&type=template&id=53094e3a&scoped=true"
import script from "./ViewSelector.vue?vue&type=script&lang=js"
export * from "./ViewSelector.vue?vue&type=script&lang=js"
import style0 from "./ViewSelector.vue?vue&type=style&index=0&id=53094e3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53094e3a",
  null
  
)

export default component.exports